import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DetailsItem from './DetailsItem';

import sectionShape from './DetailsList.sectionShape.PropType';

import s from './DetailsList.scss';

function injectContainerStyles(className, mobileLikeOnTwoColumn) {
  return classNames(className, {
    [s.mobile_like_on_two_columns_section]: mobileLikeOnTwoColumn
  });
}

function injectTitleStyles(className, mobileLikeOnTwoColumn, neverWide) {
  return classNames(className, {
    [s.mobile_like_on_two_columns_title]: mobileLikeOnTwoColumn,
    [s.never_wide_title]: neverWide
  });
}

function injectContentStyles(className, mobileLikeOnTwoColumn, neverWide) {
  return classNames(className, {
    [s.mobile_like_on_two_columns_content]: mobileLikeOnTwoColumn,
    [s.never_wide_content]: neverWide
  });
}

function injectStylesIntoChildren(children, mobileLikeOnTwoColumn, neverWide) {
  return React.Children.map(children, child =>
    React.cloneElement(child, {
      className:
        injectContainerStyles(child.props.className, mobileLikeOnTwoColumn, neverWide),
      titleClassName:
        injectTitleStyles(child.props.titleClassName, mobileLikeOnTwoColumn, neverWide),
      contentClassName:
        injectContentStyles(child.props.contentClassName, mobileLikeOnTwoColumn, neverWide)
    })
  );
}

function sectionsToItems(sections) {
  if (sections === null || sections.isEmpty()) {
    return null;
  }

  return sections.map(section => (
    <DetailsItem
      className={section.containerClassName}
      contentClassName={section.contentClassName}
      link={section.link}
      title={section.title}
      titleClassName={section.titleClassName}
      complexContent={section.useDivWrapper}
    >
      { section.content }
    </DetailsItem>
  ));
}

export default function DetailsList({ children, mobileLikeOnTwoColumn, neverWide, sections }) {
  const items = injectStylesIntoChildren(
    children ?? sectionsToItems(sections),
    mobileLikeOnTwoColumn,
    neverWide
  );

  return (<dl>{ items }</dl>);
}

function isDetailsItem(child) {
  return ((typeof child === 'object') && (child.type === DetailsItem));
}

DetailsList.propTypes = {
  children: (props, propName, componentName) => {
    const children = props[propName];

    if (children === null) {
      return undefined;
    }

    try {
      React.Children.forEach(children, (child, i) => {
        if (!isDetailsItem(child)) {
          const type = (typeof child === 'object') ? child.type.name : typeof child;

          throw new Error(
            `\`${componentName}\` should only have DetailsItems as children.\n` +
            `But child at index ${i} is of type \`${type}\``
          );
        }
      });
    } catch (e) {
      return e;
    }

    return undefined;
  },
  mobileLikeOnTwoColumn: PropTypes.bool,
  neverWide: PropTypes.bool,
  sections: sectionShape
};

DetailsList.defaultProps = {
  children: null,
  mobileLikeOnTwoColumn: false,
  neverWide: false,
  sections: null
};
